/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesAccsNecktieIcon24Solid = forwardRef('ClothesAccsNecktieIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.565 1c-.73 0-1.378.659-1.204 1.465.532 2.468 2.28 4.293 3.072 5.018L6.346 16.12a2.25 2.25 0 0 0 .454 2.27l3.535 3.89a2.25 2.25 0 0 0 3.33 0l3.535-3.89a2.25 2.25 0 0 0 .454-2.27l-3.086-8.636c.798-.725 2.56-2.554 3.076-5.028C17.812 1.652 17.165 1 16.44 1H7.565Z" })));
});
